import * as React from "react";
import config from "../config/config";
import Overview from "../components/OverviewTable/Overview";
import t from "../hooks/useTranslation";
import useDetailData from "../hooks/useDetailData";
import GpuForm from "../components/GpuForm";

import './GpuDetail.css';

function GpuDetail(props) {
    const {isLoading, error, response} = useDetailData(config.apiRouteMap.getGpu);

    return (
        <div className="GpuDetail app__main">
            <Overview
                isLoading={isLoading}
                title={t('GpuDetail')}
                error={error}
            >
                <GpuForm
                    history={props.history}
                    data={response}
                    isLoading={isLoading}
                    error={error}
                />
            </Overview>
        </div>
    );
}

export default GpuDetail;
